"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upholstery = void 0;
const types_1 = require("../../types");
const { UpholsteryEnum } = types_1.Vehicle;
exports.upholstery = [
    {
        id: UpholsteryEnum.Leather,
        name: 'Leather',
    },
    {
        id: UpholsteryEnum.Faux,
        name: 'Faux',
    },
    {
        id: UpholsteryEnum.Vinyl,
        name: 'Vinyl',
    },
    {
        id: UpholsteryEnum.Cloth,
        name: 'Cloth',
    },
];
